"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.creditAgreementSourceDocumentMetadataKeys = exports.CreditAgreementSchemaVersion = exports.BaseFacilityMechanicsSchema = exports.OvercollateralizationMethod = exports.AutoApprovalStrategy = exports.Items = exports.OvercollateralizationAmountPropertySchema = exports.BasePropertyContainerSchema = exports.PropertyContainerType = exports.LinkedAccountPropertySchema = exports.ReportConfigTypeIterable = exports.TextPropertySchema = exports.StructurePropertySchema = exports.PercentageRatePropertySchema = exports.NumberPropertyUnit = exports.DEPRECATED = exports.CommitmentAmountConfigurationPropertySchema = exports.DatePropertySchema = exports.PropertyType = void 0;
const z = __importStar(require("zod/v4"));
const Bank = __importStar(require("../Bank"));
const CreditFacility = __importStar(require("../CreditFacility"));
const DbTable = __importStar(require("../DbTables"));
const Deliverable = __importStar(require("../Deliverable"));
const FundingRequest = __importStar(require("../FundingRequest"));
const Organization = __importStar(require("../Organization"));
const Report = __importStar(require("../Report"));
const Utils = __importStar(require("../Utils"));
const Config = __importStar(require("./Config"));
/**
 * NOTE: Credit Agreement Interfaces will shared across multiple services/modules, as it serves as a central
 * configuration for the codebase.  In general, we don't want to export types/interfaces from FinleyTypes,
 * as they can typically be contained by the owner service/module
 */
/**
 * NOTE: This is a temporary home for portions CreditAgreement Domain Entity such that we can
 * more easily refactor concentration limit calculation.
 * Once fully migrated to PG, this should moved back to credit-agreements module
 */
var PropertyType;
(function (PropertyType) {
    PropertyType["AutoApprovalProperty"] = "autoApprovalProperty";
    PropertyType["AttachmentRateLimitProperty"] = "attachmentRateLimitProperty";
    PropertyType["BankAccountTypeProperty"] = "bankAccountTypeProperty";
    PropertyType["BooleanProperty"] = "booleanProperty";
    PropertyType["CashAdvanceRateProperty"] = "cashAdvanceRateProperty";
    PropertyType["ClassAllocationMethodProperty"] = "classAllocationMethodProperty";
    PropertyType["ClassLabelProperty"] = "classLabelProperty";
    PropertyType["CommitmentAmountConfigurationProperty"] = "commitmentAmountConfigurationProperty";
    PropertyType["ConcentrationLimitProperty"] = "concentrationLimitProperty";
    PropertyType["CurrencyProperty"] = "currencyProperty";
    PropertyType["DateProperty"] = "dateProperty";
    PropertyType["DeliverableReportProperty"] = "deliverableReportProperty";
    PropertyType["DeliverableProperty"] = "deliverableProperty";
    PropertyType["EligibilityTestProperty"] = "eligibilityTestProperty";
    PropertyType["FinancialCovenantProperty"] = "financialCovenantProperty";
    PropertyType["FrequencyPeriodProperty"] = "frequencyPeriodProperty";
    PropertyType["FrequencyProperty"] = "frequencyProperty";
    PropertyType["InterestRateBenchmarkProperty"] = "interestRateBenchmarkProperty";
    PropertyType["InterestRateConfigurationProperty"] = "interestRateConfigurationProperty";
    PropertyType["LiabilityAccountProperty"] = "liabilityAccountProperty";
    PropertyType["LinkedAccountProperty"] = "linkedAccountProperty";
    PropertyType["MaximumPrefundingAmountProperty"] = "maximumPrefundingAmountProperty";
    PropertyType["NumberProperty"] = "numberProperty";
    PropertyType["OvercollateralizationAmountProperty"] = "overcollateralizationAmountProperty";
    PropertyType["OvercollateralizationMethodProperty"] = "overcollateralizationMethodProperty";
    PropertyType["PercentageRateProperty"] = "percentageRateProperty";
    PropertyType["PortfolioCovenantProperty"] = "portfolioCovenantProperty";
    PropertyType["PurchasePercentageRateProperty"] = "purchasePercentageRateProperty";
    PropertyType["ReceivableAdvanceRateProperty"] = "receivableAdvanceRateProperty";
    PropertyType["ReceivableValuationRateProperty"] = "receivableValuationRateProperty";
    PropertyType["RecurringDateProperty"] = "recurringDateProperty";
    PropertyType["ReportProperty"] = "reportProperty";
    PropertyType["ReportTypeProperty"] = "reportTypeProperty";
    PropertyType["StructureProperty"] = "structureProperty";
    PropertyType["TextProperty"] = "textProperty";
})(PropertyType || (exports.PropertyType = PropertyType = {}));
const PropertyValueSchema = z.union([
    Bank.AccountTypeSchema,
    z.enum(CreditFacility.ClassLabel),
    z.string(),
    z.number(),
    z.boolean(),
    Utils.ZodFullDateStrLightWeightStruct,
    z.enum(Report.ReportTypeIterable),
    z.enum(Bank.InterestRateBenchmark),
    z.enum(CreditFacility.CreditFacilityStructureType),
    z.enum(Deliverable.v3DEPRECATED.DeliverableValueTypes),
    z.enum(Utils.FrequencyPeriod),
]);
const BasePropertySchema = z.object({
    type: PropertyType,
    name: z.string(), // free text, as named in specific credit agreement
    value: PropertyValueSchema,
    _isWrittenIn_: z.boolean(),
    section: z.optional(z.string()),
    description: z.optional(z.string()),
    _note_: z.optional(z.string()),
});
const BankAccountTypeSchema = BasePropertySchema.extend({
    type: z.literal(PropertyType.BankAccountTypeProperty),
    value: Bank.AccountTypeSchema,
});
const BooleanPropertySchema = BasePropertySchema.extend({
    type: z.literal(PropertyType.BooleanProperty),
    value: z.boolean(),
});
const CashAdvanceRatePropertySchema = BasePropertySchema.extend({
    type: z.literal(PropertyType.CashAdvanceRateProperty),
    value: z.string(), // short description of cash advance rate
    _config_: z.object({
        cashAdvanceRateConfig: Config.CashAdvanceRate.ConfigSchema,
    }),
});
const ClassLabelPropertySchema = BasePropertySchema.extend({
    type: z.literal(PropertyType.ClassLabelProperty),
    value: z.enum(CreditFacility.ClassLabel),
});
const CurrencyPropertySchema = BasePropertySchema.extend({
    type: z.literal(PropertyType.CurrencyProperty),
    value: z.number(),
    currency: z.enum(Bank.Currency),
});
exports.DatePropertySchema = BasePropertySchema.extend({
    type: z.literal(PropertyType.DateProperty),
    value: Utils.ZodFullDateStrLightWeightStruct,
});
exports.CommitmentAmountConfigurationPropertySchema = BasePropertySchema.extend({
    type: z.literal(PropertyType.CommitmentAmountConfigurationProperty),
    value: z.string(), // Set value with string description based on configuration
    currency: z.enum(Bank.Currency),
    amounts: z.array(Config.CommitmentAmount.ConfigSchema),
});
var DEPRECATED;
(function (DEPRECATED) {
    // @jendevelops deliverables-deprecated
    DEPRECATED.DeliverableReportPropertySchema = BasePropertySchema.extend({
        type: z.literal(PropertyType.DeliverableReportProperty),
        value: Report.ReportTypeSchema,
        _config_: Config.DeliverableReportProperty.ConfigSchema,
    });
})(DEPRECATED || (exports.DEPRECATED = DEPRECATED = {}));
/**
 * when extending a new type from this definition, please add its allowed values in the corresponding FE component via
 * helper function getSelectOptionsForFrequencyPeriodProperty. this enables the FE to show only the valid select options
 * for each specific type.
 */
const FrequencyPeriodPropertySchema = BasePropertySchema.extend({
    type: z.literal(PropertyType.FrequencyPeriodProperty),
    value: z.enum(Utils.FrequencyPeriod),
});
const InterestRateBenchmarkFrequencyPeriodPropertySchema = FrequencyPeriodPropertySchema.extend({
    value: z.union([
        z.literal(Utils.FrequencyPeriod.Day),
        z.literal(Utils.FrequencyPeriod.Month),
    ]),
});
const DrawRequestMaximumAmountFrequencyPeriodPropertySchema = FrequencyPeriodPropertySchema.extend({
    value: z.union([
        z.literal(Utils.FrequencyPeriod.Week),
        z.literal(Utils.FrequencyPeriod.Month),
    ]),
});
const FrequencyPropertySchema = BasePropertySchema.extend({
    type: z.literal(PropertyType.FrequencyProperty),
    value: z.number(),
    frequencyPeriod: z.enum(Utils.FrequencyPeriod),
    frequencyType: z.enum(Utils.FrequencyType),
});
const MaximumFrequencyPropertySchema = FrequencyPropertySchema.extend({
    frequencyPeriod: z.enum(Utils.FrequencyPeriod),
    frequencyType: z.literal(Utils.FrequencyType.Calendar),
});
const MaximumPrefundingAmountPropertySchema = BasePropertySchema.extend({
    type: z.literal(PropertyType.MaximumPrefundingAmountProperty),
    value: z.string(), // short description
    _config_: z.object({
        maximumPrefundingAmountConfig: Config.MaximumPrefundingAmount.ConfigSchema,
    }),
});
const InterestRateBenchmarkPropertySchema = BasePropertySchema.extend({
    type: z.literal(PropertyType.InterestRateBenchmarkProperty),
    value: z.enum(Bank.InterestRateBenchmark),
});
var NumberPropertyUnit;
(function (NumberPropertyUnit) {
    NumberPropertyUnit["Day"] = "day";
    NumberPropertyUnit["BusinessDay"] = "businessDay";
    NumberPropertyUnit["Hour24"] = "hour24";
    NumberPropertyUnit["Hour"] = "hour";
})(NumberPropertyUnit || (exports.NumberPropertyUnit = NumberPropertyUnit = {}));
const NumberPropertySchema = BasePropertySchema.extend({
    type: z.literal(PropertyType.NumberProperty),
    value: z.number(),
    unit: z.enum(NumberPropertyUnit),
});
exports.PercentageRatePropertySchema = BasePropertySchema.extend({
    type: z.literal(PropertyType.PercentageRateProperty),
    value: z.number(),
});
const AttachmentRateLimitPropertySchema = BasePropertySchema.extend({
    type: z.literal(PropertyType.AttachmentRateLimitProperty),
    /**
     * Represent property description but currently is not in use.
     * We don't expose this for the user to update or utilize.
     * Currently just setting it to the used formula by default
     */
    value: z.string(),
    // Can extend this to multiple interfaces as needed
    _config_: z.object({
        type: z.literal('formula'),
        config: Config.FullFormulaConfigSchema,
    }),
});
const ReportTypeSchema = BasePropertySchema.extend({
    type: z.literal(PropertyType.ReportTypeProperty),
    value: Report.ReportTypeSchema,
});
exports.StructurePropertySchema = BasePropertySchema.extend({
    type: z.literal(PropertyType.StructureProperty),
    value: z.enum(CreditFacility.CreditFacilityStructureType),
});
exports.TextPropertySchema = BasePropertySchema.extend({
    type: z.literal(PropertyType.TextProperty),
    value: z.string(),
});
const ClassAllocationMethodPropertySchema = BasePropertySchema.extend({
    type: z.literal(PropertyType.ClassAllocationMethodProperty),
    value: z.union([
        z.enum(FundingRequest.ClassDrawRequestAllocationMethods),
        z.enum(FundingRequest.ClassCurePaydownAllocationMethods),
        z.enum(FundingRequest.ClassCollectionsPaydownAllocationMethods),
    ]),
});
// ********************************************************
//                  FINANCIAL COVENANT
// ********************************************************
const BaseFinancialCovenantLimitSchema = z.object({
    value: z.number(),
    valueType: z.enum(Config.FinancialCovenant.LimitValueType),
});
const FinancialCovenantCurrencyLimitSchema = BaseFinancialCovenantLimitSchema.extend({
    valueType: z.literal(Config.FinancialCovenant.LimitValueType.currency),
    currency: z.enum(Bank.Currency),
});
const FinancialCovenantRatioLimitSchema = BaseFinancialCovenantLimitSchema.extend({
    valueType: z.literal(Config.FinancialCovenant.LimitValueType.ratio),
});
const FinancialCovenantPercentageLimitSchema = BaseFinancialCovenantLimitSchema.extend({
    valueType: z.literal(Config.FinancialCovenant.LimitValueType.percentage),
});
const FinancialCovenantLimitSchema = z.union([
    FinancialCovenantCurrencyLimitSchema,
    FinancialCovenantRatioLimitSchema,
    FinancialCovenantPercentageLimitSchema,
]);
// Note: below should align with "Report.ReportType" directly.
// If enough supported reports overlap, can consider merging / utilizing single source
exports.ReportConfigTypeIterable = [
    'assetVerification',
    'batchSettlement',
    'borrowingBaseServicerReport',
    'borrowingBaseCertificate',
    'disbursementNotice',
    'fundingNotice',
    'fundingRequestServicerReport',
    'invoice',
    'monthlyServicerReport',
    'noticeOfBorrowing',
    'noticeOfPrepayment',
    'paymentInKindNotice',
    'receivableResponseTapePreviewServicerReport',
    'receivablesSaleAgreement',
    'releaseNotice',
];
exports.LinkedAccountPropertySchema = BasePropertySchema.extend({
    type: z.literal(PropertyType.LinkedAccountProperty),
    value: z.string(), // bank account id
});
var PropertyContainerType;
(function (PropertyContainerType) {
    PropertyContainerType["DeliverableReportPropertyContainer"] = "deliverableReportPropertyContainer";
    PropertyContainerType["LinkedAccountPropertyContainer"] = "linkedAccountPropertyContainer";
    PropertyContainerType["ReportTypePropertyContainer"] = "reportTypePropertyContainer";
    PropertyContainerType["TextPropertyContainer"] = "textPropertyContainer";
})(PropertyContainerType || (exports.PropertyContainerType = PropertyContainerType = {}));
const PropertyContainerContentsSchema = z.union([
    z.array(DEPRECATED.DeliverableReportPropertySchema), // @jendevelops deliverables-deprecated
    z.array(exports.LinkedAccountPropertySchema),
    z.array(ReportTypeSchema),
    z.array(exports.TextPropertySchema),
]);
exports.BasePropertyContainerSchema = z.object({
    type: z.enum(PropertyContainerType),
    name: z.string(), // free text, as named in specific credit agreement
    contents: PropertyContainerContentsSchema,
    _isWrittenIn_: z.boolean(),
    section: z.optional(z.string()),
    description: z.optional(z.string()),
    _note_: z.optional(z.string()),
});
// @jendevelops deliverables-deprecated
const DeliverablePropertyContainerSchema = exports.BasePropertyContainerSchema.extend({
    type: z.literal(PropertyContainerType.DeliverableReportPropertyContainer),
    contents: z.array(DEPRECATED.DeliverableReportPropertySchema), // required documents
    deliverableType: z.enum(Deliverable.v3DEPRECATED.DeliverableType),
    frequency: z.enum(Utils.FrequencyPeriod),
    dueDates: z.array(Utils.ZodFullDateStrStruct),
});
const LinkedAccountPropertyContainerSchema = exports.BasePropertyContainerSchema.extend({
    type: z.literal(PropertyContainerType.LinkedAccountPropertyContainer),
    contents: z.array(exports.LinkedAccountPropertySchema),
});
const ReportTypePropertyContainerSchema = exports.BasePropertyContainerSchema.extend({
    type: z.literal(PropertyContainerType.ReportTypePropertyContainer),
    contents: z.array(ReportTypeSchema),
});
exports.OvercollateralizationAmountPropertySchema = BasePropertySchema.extend({
    type: z.literal(PropertyType.OvercollateralizationAmountProperty),
    value: z.number(),
    valueType: z.literal('percent'), // To be extended if desired, but unlikely at this time
});
var Items;
(function (Items) {
    let PartyType;
    (function (PartyType) {
        PartyType["AdminAgent"] = "adminAgent";
        PartyType["BackupServicer"] = "backupServicer";
        PartyType["Borrower"] = "borrower";
        PartyType["CapitalProvider"] = "capitalProvider";
        PartyType["CapitalProviderRepresentative"] = "capitalProviderRepresentative";
        PartyType["CollectionAccountBank"] = "collectionAccountBank";
        PartyType["PayingAgent"] = "payingAgent";
        PartyType["Servicer"] = "servicer";
        PartyType["VerificationAgent"] = "verificationAgent";
    })(PartyType = Items.PartyType || (Items.PartyType = {}));
    let CustomerType;
    (function (CustomerType) {
        /**
         * The customer on whose behalf we have configured this facility. Most commonly this will be
         * a borrower using Finley to generate loan tapes, compute a borrowing base report, and submit
         * funding requests; or a capital provider set up for calc verification.
         *
         * This customer has the broadest set of permissions on a facility.
         */
        CustomerType["Owner"] = "owner";
        /**
         * A customer who is not an {@link Owner}, but may log in to Finley's systems. Examples: a
         * capital provider who logs in to approve o borrower Owner's funding request; or a borrower
         * who logs in to do remediation on a capital provider Owner's verification facility.
         *
         * The set of permissions allowed here is currently poorly defined, but this will become more
         * explicit over time.
         */
        CustomerType["Limited"] = "limited";
        /**
         * This party exists in the system for record-keeping, but does not log in to or interact with
         * our system directly.
         */
        CustomerType["None"] = "none";
    })(CustomerType = Items.CustomerType || (Items.CustomerType = {}));
    let InterestRateBase;
    (function (InterestRateBase) {
        InterestRateBase["Fixed"] = "fixed";
        InterestRateBase["Benchmark"] = "benchmark";
    })(InterestRateBase = Items.InterestRateBase || (Items.InterestRateBase = {}));
    const CapitalProviderConfigSchema = z.object({
        interestRateBase: z.enum(InterestRateBase),
    });
    const BaseItemSchema = z.object({
        _id_: z.string(),
        section: z.optional(z.string().nullable()),
        _isWrittenIn_: z.boolean(),
    });
    const UserSchema = z.object({
        id: z.string(),
        email: z.string(),
        firstName: z.string(),
        lastName: z.string(),
    });
    const BaseEntitySchema = z.object({
        entity: z.union([
            UserSchema,
            Organization.BaseOrganizationSchema,
            DbTable.BankAccountWithInstitutionSchema,
        ]),
        section: z.optional(z.string().nullable()),
        _isWrittenIn_: z.boolean(),
    });
    const UserItemSchema = BaseItemSchema.extend({
        primaryContact: BooleanPropertySchema,
        _isWrittenIn_: z.boolean(),
    });
    const UserEntitySchema = BaseEntitySchema.extend({
        entity: UserSchema,
        primaryContact: BooleanPropertySchema,
    });
    const BankAccountItemSchema = BaseItemSchema.extend({
        type: BankAccountTypeSchema,
        cashAdvanceRate: z.optional(CashAdvanceRatePropertySchema),
    });
    const BankAccountEntitySchema = BaseEntitySchema.extend({
        entity: DbTable.BankAccountWithInstitutionSchema,
        type: BankAccountTypeSchema,
        cashAdvanceRate: z.optional(CashAdvanceRatePropertySchema),
    });
    const BaseOrganizationEntitySchema = BaseEntitySchema.extend({
        entity: Organization.BaseOrganizationSchema,
    });
    const BasePartyItemSchema = BaseItemSchema.extend({
        type: z.enum(PartyType),
        customerType: z.enum(CustomerType),
        users: UserItemSchema.array(),
    });
    Items.BasePartyEntitySchema = BaseOrganizationEntitySchema.extend({
        type: z.enum(PartyType),
        customerType: z.enum(CustomerType),
        users: UserEntitySchema.array(),
    });
    Items.AdminAgentItemSchema = BasePartyItemSchema.extend({
        type: z.literal(PartyType.AdminAgent),
        customerType: z.literal(CustomerType.None),
        feeDescription: z.optional(exports.TextPropertySchema),
    });
    Items.AdminAgentEntitySchema = Items.BasePartyEntitySchema.extend({
        type: z.literal(PartyType.AdminAgent),
        customerType: z.literal(CustomerType.None),
        feeDescription: z.optional(exports.TextPropertySchema),
    });
    Items.BackupServicerItemSchema = BasePartyItemSchema.extend({
        type: z.literal(PartyType.BackupServicer),
        customerType: z.literal(CustomerType.None),
    });
    Items.BackupServicerEntitySchema = Items.BasePartyEntitySchema.extend({
        type: z.literal(PartyType.BackupServicer),
        customerType: z.literal(CustomerType.None),
    });
    Items.BorrowerItemSchema = BasePartyItemSchema.extend({
        type: z.literal(PartyType.Borrower),
        customerType: z.enum(CustomerType),
        borrowerEntityName: exports.TextPropertySchema,
        bankAccounts: BankAccountItemSchema.array(),
    });
    Items.BorrowerEntitySchema = Items.BasePartyEntitySchema.extend({
        type: z.literal(PartyType.Borrower),
        customerType: z.enum(CustomerType),
        borrowerEntityName: exports.TextPropertySchema,
        bankAccounts: BankAccountEntitySchema.array(),
    });
    const CapitalProviderRepresentativeItemSchema = BasePartyItemSchema.extend({
        type: z.literal(PartyType.CapitalProviderRepresentative),
        customerType: z.literal(CustomerType.None),
    });
    const CollectionAccountBankItemSchema = BasePartyItemSchema.extend({
        type: z.literal(PartyType.CollectionAccountBank),
        customerType: z.literal(CustomerType.None),
    });
    const CollectionAccountBankEntitySchema = Items.BasePartyEntitySchema.extend({
        type: z.literal(PartyType.CollectionAccountBank),
        customerType: z.literal(CustomerType.None),
    });
    const PayingAgentItemSchema = BasePartyItemSchema.extend({
        type: z.literal(PartyType.PayingAgent),
        customerType: z.literal(CustomerType.None),
    });
    const PayingAgentEntitySchema = Items.BasePartyEntitySchema.extend({
        type: z.literal(PartyType.PayingAgent),
        customerType: z.literal(CustomerType.None),
    });
    const ServicerItemSchema = BasePartyItemSchema.extend({
        type: z.literal(PartyType.Servicer),
        customerType: z.literal(CustomerType.None),
        feeDescription: z.optional(exports.TextPropertySchema),
        feePaymentDateDescription: z.optional(exports.TextPropertySchema),
    });
    const ServicerEntitySchema = Items.BasePartyEntitySchema.extend({
        type: z.literal(PartyType.Servicer),
        customerType: z.literal(CustomerType.None),
        feeDescription: z.optional(exports.TextPropertySchema),
        feePaymentDateDescription: z.optional(exports.TextPropertySchema),
    });
    const VerificationAgentItemSchema = BasePartyItemSchema.extend({
        type: z.literal(PartyType.VerificationAgent),
        customerType: z.literal(CustomerType.None),
    });
    const VerificationAgentEntitySchema = Items.BasePartyEntitySchema.extend({
        type: z.literal(PartyType.VerificationAgent),
        customerType: z.literal(CustomerType.None),
    });
})(Items || (exports.Items = Items = {}));
// items
// orgType should eventually be consolidated into partyType
// ======== SUB-CATEGORIES ========
// ======== FUNDING REQUEST COMPONENT ========
var AutoApprovalStrategy;
(function (AutoApprovalStrategy) {
    AutoApprovalStrategy["SpecificHour"] = "specificHour";
    AutoApprovalStrategy["WithDelay"] = "withDelay";
    AutoApprovalStrategy["Immediate"] = "immediate";
})(AutoApprovalStrategy || (exports.AutoApprovalStrategy = AutoApprovalStrategy = {}));
const AutoApprovalPropertySchema = BasePropertySchema.extend({
    type: z.literal(PropertyType.AutoApprovalProperty),
    approvalStrategy: z.enum(AutoApprovalStrategy),
    value: z.number(),
    unit: z.optional(z.enum(NumberPropertyUnit)),
});
var OvercollateralizationMethod;
(function (OvercollateralizationMethod) {
    OvercollateralizationMethod["ClassSubordination"] = "classSubordination";
})(OvercollateralizationMethod || (exports.OvercollateralizationMethod = OvercollateralizationMethod = {}));
const OvercollateralizationMethodPropertySchema = BasePropertySchema.extend({
    type: z.literal(PropertyType.OvercollateralizationMethodProperty),
    value: z.enum(OvercollateralizationMethod),
});
const FundingRequestComponentBasePropertiesSchema = z.object({
    // optional properties
    minimumAmount: z.optional(CurrencyPropertySchema),
    incrementAmount: z.optional(CurrencyPropertySchema),
    maximumFrequency: z.optional(MaximumFrequencyPropertySchema),
    submissionNoticePeriod: z.optional(NumberPropertySchema),
    requiredDocumentation: z.optional(ReportTypePropertyContainerSchema),
    sourceAccounts: z.optional(LinkedAccountPropertyContainerSchema),
    destinationAccounts: z.optional(LinkedAccountPropertyContainerSchema),
});
// ======== CATEGORIES ========
const BaseBorrowingBaseMechanicsSchema = z.object({
    // optional properties
    reportingDateDescription: z.optional(exports.TextPropertySchema),
    concentrationLimitTransitionDate: z.optional(exports.DatePropertySchema),
});
exports.BaseFacilityMechanicsSchema = z.object({
    // mandatory properties
    closingDate: exports.DatePropertySchema,
    finalMaturityDate: exports.DatePropertySchema,
    structure: exports.StructurePropertySchema,
    // optional properties
    amortizationPeriodStart: z.optional(exports.DatePropertySchema),
    amortizationPeriodEnd: z.optional(exports.DatePropertySchema),
    callProtectionExpirationDate: z.optional(exports.DatePropertySchema),
    callProtectionValue: z.optional(exports.PercentageRatePropertySchema),
    commitmentPeriodEffectiveDate: z.optional(exports.DatePropertySchema),
    externalFacilityId: z.optional(exports.TextPropertySchema),
    governingLaw: z.optional(exports.TextPropertySchema),
    interestRateCeiling: z.optional(exports.PercentageRatePropertySchema),
    minimumUtilization: z.optional(exports.PercentageRatePropertySchema),
    revolvingCommitmentTermination: z.optional(exports.DatePropertySchema),
    seniority: z.optional(exports.TextPropertySchema),
    yieldMaintenance: z.optional(exports.DatePropertySchema),
});
var CreditAgreementSchemaVersion;
(function (CreditAgreementSchemaVersion) {
    CreditAgreementSchemaVersion["1.0"] = "1.0";
})(CreditAgreementSchemaVersion || (exports.CreditAgreementSchemaVersion = CreditAgreementSchemaVersion = {}));
const CreditAgreementMetadataSchema = z.object({
    id: z.string(),
    facilityType: z.enum(DbTable.FacilityTypeIterable),
    creditFacilityId: z.string(),
    effectiveFrom: z.number(),
    effectiveTo: z.number(),
    version: z.string(), // CreditAgreementAmendment.InternalModification
    _schemaVersion_: z.string(), // MajorBreakingChange.MinorPatch
    s3Path: z.optional(z.string()),
    _note_: z.optional(z.string()),
    // WIP only property that points to current CA id
    // WIPs can only be committed against this credit agreement id to
    // ensure serial commits
    _currentCreditAgreementId_: z.optional(z.string()),
});
exports.creditAgreementSourceDocumentMetadataKeys = [
    'id',
    'facilityType',
    'creditFacilityId',
    'effectiveFrom',
    'effectiveTo',
    'version',
    '_schemaVersion_',
    's3Path',
    '_note_',
    '_currentCreditAgreementId_',
];
//# sourceMappingURL=DomainEntity.js.map